import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import config from '../../config';
import { useGlobalContext } from '../../GlobalContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'; // Add this to your imports
import { GetById, UpdatePassword } from '../../service/UserService';

export default function MyPassword() {
  const {
    isLoading,
    setIsLoading,
    isAppError,
    setAppError,
    appErrorMessage,
    setAppErrorMessage,
    appErrorTitle,
    setAppErrorTitle,
    appErrorMode,
    setAppErrorMode,
    appUser
  } = useGlobalContext();

  const id = appUser.id;

  const [user, setUser] = useState({});

  const [oldPassword, setOldPassword] = useState('');
  const [showOldPassword, setShowOldPassword] = useState(false);

  const [newPassword, setNewPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');

  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const fetchUserById = async () => {
    try {
      setIsLoading(true);
      var response = await GetById(id);
      if (response.status === 200) {
        setUser(response.user);
      }
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load data");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  const saveMember = async (event) => {
    event.preventDefault();

    if (!oldPassword) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Old Password is required");
      setAppErrorMode("error");
      return;
    }

    if (!newPassword) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("New Password is required");
      setAppErrorMode("error");
      return;
    }

    if (newPassword !== passwordConfirm) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Re-type Password does not match the Password");
      setAppErrorMode("error");
      return;
    }

    setIsLoading(true);

    try {
      const response = await UpdatePassword(id, oldPassword, newPassword, passwordConfirm);
      console.log("user", response);
      if (response.status === 200) {
        setAppError(true);
        setAppErrorTitle("Action Response");
        setAppErrorMessage(response.message || "Member Password Successfully Updated");
        setAppErrorMode("success");
        window.location.href = "/mypassword";
      }
      else {
        setAppError(true);
        setAppErrorTitle("Error");
        setAppErrorMessage(response.message || "Failed to add member. Please try again.");
        setAppErrorMode("error");
      }
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to add member. Please try again.");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    if (id != null && id != undefined && id != "") {
      fetchUserById();
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>My Password Manage | {config.appName}</title>
      </Helmet>

      <div className="container">
        <div className="page">
          <div className="page-heading">
            <h1> My Password Update</h1>
            <span>
              <Link to="/"> Dashboard </Link> / My Password Manage
            </span>
          </div>

          <div className="page-content">
            <div className="portal">
              <div className="portal-body">
                <form onSubmit={saveMember} encType='multipart/form-data'>
                  <div className="row">

                    {/* Old Password Field (newly added) */}
                    <div className="col-lg-4 col-md-4 col-sm-6 col-12">
                      <div className="mb-3">
                        <label className="form-label">Old Password</label>
                        <div className="input-group">
                          <input
                            className="form-control"
                            type={showOldPassword ? 'text' : 'password'}
                            value={oldPassword}
                            onChange={(e) => setOldPassword(e.target.value)}
                          />
                          <span
                            className="input-group-text"
                            onClick={() => setShowOldPassword(!showOldPassword)}
                            style={{ cursor: 'pointer' }}
                          >
                            <FontAwesomeIcon icon={showOldPassword ? faEyeSlash : faEye} />
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* New Password Field */}
                    <div className='col-lg-4 col-md-4 col-sm-6 col-12'>
                      <div className="mb-3">
                        <label className="form-label">New Password</label>
                        <div className="input-group">
                          <input
                            className='form-control'
                            type={showNewPassword ? 'text' : 'password'}
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                          />
                          <span className="input-group-text" onClick={() => setShowNewPassword(!showNewPassword)} style={{ cursor: 'pointer' }}>
                            <FontAwesomeIcon icon={showNewPassword ? faEyeSlash : faEye} />
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Re-type Password Field */}
                    <div className='col-lg-4 col-md-4 col-sm-6 col-12'>
                      <div className="mb-3">
                        <label className="form-label">Re-type Password</label>
                        <div className="input-group">
                          <input
                            className='form-control'
                            type={showConfirmPassword ? 'text' : 'password'}
                            value={passwordConfirm}
                            onChange={(e) => setPasswordConfirm(e.target.value)}
                          />
                          <span className="input-group-text" onClick={() => setShowConfirmPassword(!showConfirmPassword)} style={{ cursor: 'pointer' }}>
                            <FontAwesomeIcon icon={showConfirmPassword ? faEyeSlash : faEye} />
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className='clearfix'></div>
                    <div className='col-12 text-end'>
                      <div className="mb-3">
                        <button type='reset' className='btn btn-danger btn-md'>
                          <i className="ri-reset-right-line"></i> Reset
                        </button>
                        &nbsp;&nbsp;
                        <button type='submit' className='btn btn-success btn-md'>
                          <i className="ri-check-fill"></i> Update Password
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};